import { SET_GAME_DATA } from "../action-types";

export const setGameData = (localizedNamespace, data) => ({
    type: SET_GAME_DATA,
    payload: {
        data,
        localizedNamespace,
    },
});
